import {
    DEALERWITHDRAWEMONEYLIST_SUCCESS,
    DEALERWITHDRAWEMONEYLIST_FAILED,
    RESET_DEALERWITHDRAWEMONEYLIST,
    LOADING_DEALERWITHDRAWEMONEYLIST,
    NETWORK_ERROR_DEALERWITHDRAWEMONEYLIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERWITHDRAWEMONEYLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERWITHDRAWEMONEYLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERWITHDRAWEMONEYLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERWITHDRAWEMONEYLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERWITHDRAWEMONEYLIST:
            return (state = initialState);
        default:
            return state;
    }
};
